
<template>
  <v-col class="d-flex hot-job-box flex-column pb-0">
    <v-row class="hot-job-img" justify="center">
      <img :src="item.Company.HotJobLogoLink" alt="company-logo" />
    </v-row>
    <v-row class="flex-column hot-job-content">
      <v-col class="py-5">
        <p
          class="mb-0 primary--text font-weight-medium"
          :class="smallerHeaderSize ? 'hot-job-hdr-small' : 'hot-job-hdr'"
        >
          {{ item.Company.CompanyDisplayName }}
        </p>

        <p
          class="mb-0 lightBlack--text font-weight-medium"
          :class="smallerHeaderSize ? 'display-14' : 'display-16'"
        >
          {{ item.JobContent.Name }}
        </p>

        <v-btn
          rounded
          color="tertiary"
          class="white--text mb-2 mt-3 job-btn"
          :small="$vuetify.breakpoint.xs ? true : false"
          :to="`/job/${item.JobInfo.JobCode}/${item.JobInfo.Hash}`"
          @click.native="clicked($event)"
        >
          לצפייה בפרטי המשרה
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import gtm from '@/lib/gtm';
import { HOT_JOB_CLICK } from '@/lib/api.js';

export default {
  props: {
    item: {
      type: Object,
      required: false,
      default: () => {},
    },
    isLoadMoreBanner: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      text: 'משרות',
      headerMaxChars: 19,
    };
  },
  computed: {
    smallerHeaderSize() {
      let hdrLength = this.item.Company.CompanyDisplayName.length;
      if (hdrLength > this.headerMaxChars) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    clicked() {
      try {
        this.$axios
          .get(`${HOT_JOB_CLICK}/${this.item.JobInfo.JobCode}`)
          .then(() => {
            gtm({
            category: 'SearchResult',
            action: 'JobBanners',
            label: this.item.JobContent.Name,
            event: this.isLoadMoreBanner? 'JobBanner_loadMore': 'JobBanners',
            });
            gtm({
              category: 'SearchResult',
              action: 'JobBanners_job_code',
              label: this.item.JobInfo.JobCode,
              event: this.isLoadMoreBanner? 'JobBanner_loadMore': 'JobBanners',
            });
          });
      } catch (e) {
        console.log('hot job item click', e);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.hot-job-box {
  width: 100%;
  border: 1px solid #94acc0;
  border-radius: 5px;
  position: relative;
  text-align: center;
  box-shadow: inset 0 0 1px #f2f2f2;
  min-width: 220px;
  margin: 0 10px;
  @media only screen and (min-width: 700px) {
    max-width: 280px;
  }
  p.lightBlack--text {
    letter-spacing: -0.45px;
    @media only screen and (max-width: 500px) {
      line-height: 1.1;
    }
  }
}

.hot-job-img {
  background-color: #fff;

  margin-bottom: 2px;
  border-radius: 5px;
  padding: 14px 0;
  height: 70px;
  @media only screen and (min-width: 600px) {
    padding: 35px 0;
    height: 110px;
  }
  img {
    align-self: center;
  }
}
.hot-job-hdr {
  font-size: 16px;
  @media only screen and (min-width: 600px) {
    font-size: 20px;
  }
  @media only screen and (min-width: 968px) {
    font-size: 24px;
  }
}
.hot-job-hdr-small {
  font-size: 12px;
  @media only screen and (min-width: 600px) {
    font-size: 12px;
  }
  @media only screen and (min-width: 968px) {
    font-size: 16px;
  }
}

.hot-job-content {
  background-color: #f2f3f5;
  border: 5px solid #fff;
  border-radius: 10px;
  height: 150px;
  @media only screen and (min-width: 600px) {
    height: 180px;
  }
}
.job-btn {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 180px;
  &:hover {
    background-color: $primary !important;
  }
  @media only screen and (min-width: 600px) {
    width: 200px;
    bottom: 20px;
  }
}
</style>

